import { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { EnsuranceMoments } from '@components/ensuranceMoments';
import { FindPlans } from '@screens/home/newLanding/plans/FindPlans';
import { SlideShow } from '@screens/home/slideshow/SlideShow';
import TagManager from 'react-gtm-module';
import { PickPlan } from '@screens/home/newLanding/plans/PickPlan';
import { NewQuotation } from '../components/Tab/NewQuotation';
import { HeroAction } from '../components/screens/home/hero/HeroAction';
import { FormInformation } from '@options/FormInformation';
import { InsuranceLogos } from '@screens/home/newLanding/insurances/InsuranceLogos';
import { Condition } from '@screens/home/newLanding/condition/Condition';
import { Questions } from '@screens/home/newLanding/questions';
import { useTrackingStore } from '../store/TrackingStore';
import { useTokenStore } from '../store/TokenStore';
import Assistances from '@screens/home/assistances/assistances';
import { HaveQuotationWrapper } from '@components/Tab/HaveQuotationWrapper';
import { usePolicyStore } from '@store/policyStore';
import AntiFraudHome from "@components/antiFraud/AntiFraudHome";
import ModalBanner from '@modals/ModalBanner/ModalBanner';
import { useTracking } from '@hooks/useTracking';

const useStyles = makeStyles({
  root: {
    paddingBottom: '40px',
    paddingTop: '40px',
    backgroundSize: '20%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right',
    backgroundPositionY: '35%',
  },
});

const DataLayer = {
  event: 'CSform_step_0_view',
  eventCategory: 'Formulario.Seguro.Auto.v2',
  eventAction: 'step_0_view',
  eventLabel: undefined,
  telefono: undefined,
  correo: undefined,
  noCotizacion: undefined,
  modelo: undefined,
  marca: undefined,
  anio: undefined,
  paquete: undefined,
  forma_pago: undefined,
  aseguradora: undefined,
  tarjeta: undefined,
  tipo_tarjeta: undefined,
  tipo_vehiculo: undefined,
  colaborador: undefined,
  cupon: undefined,
};

const tagManagerArgs = {
  dataLayer: DataLayer,
};

interface Props {
  padding?: number;
  elevation?: number;
  isAbsolute: boolean;
  showInfo: Function;
}

export const Home = ({
  padding = 16,
  elevation = 12,
  isAbsolute = false,
}: Props) => {
  const classes = useStyles();
  const [isNewQuotation, setIsNewQuotation] = useState(false);
  const [isHeroAction, setIsHeroAction] = useState(true);
  const [isFormInformation, setIsFormInformation] = useState(false);
  const { setToken, token } = useTokenStore();
  const { tracking, setDataTracking } = useTrackingStore();
  const [showHaveQuotation, setShowHaveQuotation] = useState(false);
  const {removePolicyInfo} = usePolicyStore();
  const [showModal, setShowModal] = useState(true);
  const {getTrackingAndToken} = useTracking()

  useEffect(() => {
    sessionStorage.clear();
    removePolicyInfo();
    window.scroll(0, 0);
    getTrackingAndToken()
  }, []);
  useEffect(() => {
    window.scroll(0, 0);
    setToken(token);
    setDataTracking(tracking);
    TagManager.dataLayer(tagManagerArgs);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className={classes.root}>
      {/* <SlideShow /> */}
      <FindPlans
        isAbsolute={isAbsolute}
        setShowHaveQuotation={setShowHaveQuotation}
        setIsHeroAction={setIsHeroAction}
        setIsNewQuotation={setIsNewQuotation}
      />
      <EnsuranceMoments />
      <PickPlan />
      <Assistances />
      <InsuranceLogos />
      {showHaveQuotation && (
        <HaveQuotationWrapper
          setShowHaveQuotation={setShowHaveQuotation}
          setIsHeroAction={setIsHeroAction}
        />
      )}
      {isHeroAction && (
        <HeroAction
          padding={16}
          elevation={12}
          setIsNewQuotation={setIsNewQuotation}
          setIsHeroAction={setIsHeroAction}
        />
      )}
      {isNewQuotation && (
        <NewQuotation
          padding={padding}
          elevation={elevation}
          isAbsolute={isAbsolute}
          setIsHeroAction={setIsHeroAction}
          setIsNewQuotation={setIsNewQuotation}
          setIsFormInformation={setIsFormInformation}
        />
      )}
      {isFormInformation && (
        <FormInformation
          isFormInformation={isFormInformation}
          setIsFormInformation={setIsFormInformation}
        />
      )}
      <Condition />
      <AntiFraudHome/>
      <Questions />

      {showModal && (
        <ModalBanner 
          setShowModal={setShowModal}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};
